/*
 * healthmart
 * version 2.2
 * http://www.healthmart.com
 *
 * Copyright (c) 2019 healthmart ltd
 * Author healthmart ltd <support@healthmart.com>
 * Licensed under the MIT license.
 */
import {Component, OnInit, Input, Output, EventEmitter, Inject} from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'app-input-num-control',
    templateUrl: './input-num-control.component.html',
    styleUrls: ['./input-num-control.component.scss'],
    standalone: false
})
export class InputNumControlsComponent implements OnInit {        
    
    @Input() quantity: number;
    @Input() valueIndex: number;
    @Input() id: number;

    @Output() emptyDecorator: EventEmitter<any> = new EventEmitter();
    @Output() QuantityChange: EventEmitter<any> = new EventEmitter<any>();

    constructor(private router: Router) {}
    
    ngOnInit() {}

    public changeCount(operation) {
        if (operation === 'remove') {
            this.quantity -= 1;
        } else if (operation === 'add') {
            this.quantity = 1;
        }

        if(this.quantity < 0) {
            this.quantity = 0;
        }
        this.QuantityChange.emit({qty: this.quantity,index: this.valueIndex, id: this.id});
    }
}